<template>
  <div>
    <template v-if="isJson">
      <template v-if="json.t == 'P'">
        <div class="flex-row-left" style="max-height: 30px;">
          <div class="icon-area">
            <div style="transform: translateY(2px);">
              <v-icon color="rgba(0,0,0,.54)" :size="20">{{ $utils.postCodeToIcon(json.type) }}</v-icon>
            </div>
          </div>
          <div class="icon-comment">
            {{ $T('common.registered', { tgt: $utils.postCodeToName(json.type) }) }}
          </div>
        </div>
      </template>
      <template v-else-if="json.t == 'A'">
        <div class="flex-row-left">
          <div class="icon-area">
            <div style="transform: translateY(1px);">
              <c-svg t="photo" class="photo" style="color: rgba(0,0,0,.54); width: 18; height: 18;"></c-svg>
            </div>
          </div>
          <div class="icon-comment">x {{ json.fids.length }}</div>
        </div>
      </template>
      <template v-else-if="json.t == 'E'">
        <div class="flex-row-left">
          <div class="icon-area">
            <div style="transform: translateY(-1px);">
              <v-icon color="rgba(0,0,0,.54)" :size="20">calendar_today</v-icon>
            </div>
          </div>
          <div class="icon-comment">
            {{ $T('common.registered', { tgt: $T('attributes.event') }) }}
          </div>
        </div>
      </template>
      <template v-else-if="json.t == 'CALL'">
        <div class="flex-row-left">
          <div class="icon-area">
            <div>
              <v-icon color="rgba(0,0,0,.54)" :size="18">phone</v-icon>
            </div>
          </div>
        </div>
      </template>
      <div v-else>UNSUPPORTED</div>
    </template>
    <template v-else>
      <span>{{ msg }}</span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, required: true },
  },
  data() {
    return {};
  },
  mounted() {},
  watch: {},
  computed: {
    isJson() {
      return this.value.startsWith('{');
    },
    msg() {
      return this.value.startsWith('\\') ? this.value.substring(1) : this.value;
    },
    json() {
      return JSON.parse(this.value);
    },
  },
  methods: {},
};
</script>

<style>
.icon-area {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 20px;
}
.icon-comment {
  text-overflow: ellipsis;
  overflow: hidden;
  padding-left: 5px;
  vertical-align: top;
  max-height: 30px;
}
</style>
